import { render, staticRenderFns } from "./MiddleEllipsisText.vue?vue&type=template&id=92ded2e2&scoped=true&"
import script from "./MiddleEllipsisText.vue?vue&type=script&lang=ts&"
export * from "./MiddleEllipsisText.vue?vue&type=script&lang=ts&"
import style0 from "./MiddleEllipsisText.vue?vue&type=style&index=0&id=92ded2e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ded2e2",
  null
  
)

export default component.exports